import { render, staticRenderFns } from "./comfyuiPerson.vue?vue&type=template&id=848e8b88&scoped=true&"
import script from "./comfyuiPerson.vue?vue&type=script&lang=js&"
export * from "./comfyuiPerson.vue?vue&type=script&lang=js&"
import style0 from "./comfyuiPerson.vue?vue&type=style&index=0&id=848e8b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848e8b88",
  null
  
)

export default component.exports